import { render, staticRenderFns } from "./ProfilePhotos.vue?vue&type=template&id=2106d0f9&"
import script from "./ProfilePhotos.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports